import fetcher from '../utils/api';

const accountService = {
  getInfo: async () => fetcher('users/', 'GET', true, {}),
  updateInfo: async (body) => fetcher('users/', 'PATCH', true, body),
  updateUserCustomization: async ({ id, bodyParams }) => {
    return fetcher(`users/customization/`, 'PATCH', true, bodyParams);
  },
  updateGrowthState: async (body) => fetcher('users/', 'PATCH', true, body),
  updateUserSettings: async (body) => fetcher(`users/user_settings/`, 'PATCH', true, body),
  getUserSettings: async () => fetcher(`users/user_settings/`, 'GET', true),
  getAnalytics: async () => fetcher('users/analytics/', 'GET', true),
  updateFeaturePresentation: async (body) => fetcher('feature_presentation/', 'POST', true, body),
  affiliateSignup: async (referringUserId) =>
    fetcher('users/affiliate_signup/', 'POST', true, {
      referring_user_id: referringUserId
    }),
  scheduleDesktopReminder: async () => fetcher('users/switch_to_desktop/', 'POST', true),
  getAffiliateLink: async () => fetcher('users/affiliate_link/', 'GET', true),
  getAffiliateLinkFromId: async (userId) => fetcher(`users/affiliate_link/${userId ? `?user_id=${userId}` : ''}`, 'GET', false),
  getOTP: async () => fetcher(`users/otp/`, 'GET', true),

  getJoinableTeams: async ({ searchQuery, skip, getFirst, excludeAdded, excludeInactive }) => {
    const additionalParams = [];
    // name query

    if (searchQuery && searchQuery.trim().length > 1) {
      additionalParams.push(`name=${encodeURIComponent(searchQuery.trim())}`);
    }

    if (skip !== undefined && skip !== null) {
      additionalParams.push(`skip=${encodeURIComponent(skip)}`);
    }

    if (getFirst !== undefined && getFirst !== null) {
      additionalParams.push(`get_first=${encodeURIComponent(getFirst)}`);
    }
    if (excludeAdded !== undefined && excludeAdded !== null) {
      additionalParams.push(`exclude_added=${encodeURIComponent(excludeAdded)}`);
    }
    if (excludeInactive !== undefined && excludeInactive !== null) {
      additionalParams.push(`exclude_inactive=${encodeURIComponent(excludeInactive)}`);
    }
    return fetcher('user_organizations/joinable/' + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`, 'GET', true);
  },
  checkForJoinableTeams: async () => fetcher('user_organizations/check_joinable/', 'GET', true),
  getAllowedDomain: async () => {
    return fetcher('user_organizations/allowed_domain/', 'GET', true);
  },
  listUserOrganizations: async ({ searchQuery, skip, getFirst }) => {
    const additionalParams = [];
    // name query

    if (searchQuery && searchQuery.trim().length > 1) {
      additionalParams.push(`name=${encodeURIComponent(searchQuery.trim())}`);
    }

    if (skip !== undefined && skip !== null) {
      additionalParams.push(`skip=${encodeURIComponent(skip)}`);
    }

    if (getFirst !== undefined && getFirst !== null) {
      additionalParams.push(`get_first=${encodeURIComponent(getFirst)}`);
    }
    return fetcher('user_organizations/' + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`, 'GET', true);
  },
  getUserDocumentsForActiveTeam: async () => fetcher('users/documents/', 'GET', true),
  sendVerificationEmail: async (email) => fetcher('users/change_email_request/', 'POST', true, email),
  verifyUserEmail: async (uuid) => fetcher(`users/change_email_request/${uuid}/fulfill/`, 'PUT', true),
  fetchChangeEmailRequest: async (uuid) => fetcher(`users/change_email_request/${uuid}/`, 'GET', true),
  trackOnboardingAnswers: async (body) => fetcher('users/onboarding_answers/', 'POST', true, body),
  deleteUser: async (email) => fetcher('users/delete/', 'PUT', true, { email })
};

export default accountService;
